module.exports = __webpack_public_path__ + "assets/share-edit-active.60dae91f.svg";